<template>
  <div id="page" class="container-fluid">
    <div class="alert alert-danger mt-4" role="alert" v-show="showAlert">
      No episodes were found for the specified employer
    </div>
      <div class="row header mx-4 my-4">
        <div class="col">
          <h1>Patient Detail</h1>
        </div>
      </div>
    <div class="container-fluid">
      <div class="row patient-summary-header pt-2">
        <div class="col-6">
          <h5>PATIENT SUMMARY</h5>
        </div>
        <div class="col-6">
          <h5>INSURANCE</h5>
        </div>
      </div>
      <div class="row patient-summary py-2">
        <div class="patient-info col-4">
          <img v-if="squareImage" class="headshot" :src="patient.imageUrl"/>
          <div v-if="!squareImage" class="rectangle-headshot-container">
            <img class="rectangle-headshot" :src="patient.imageUrl"/>
          </div>
          <div>
          <span class="field-label">Name: </span><a @click.prevent="editPatient(patient.organizationPatientId)"
                                                    href="#">{{ patient.firstName + ' ' + patient.lastName }}&nbsp;&nbsp;<font-awesome-icon
            size="sm" :icon="['far', 'edit']"/>
        </a><br>
          <span class="field-label">Birth Date: </span>{{formatBirthDate(patient.dob)}}<br>
          <span class="field-label">MRN: </span>{{ patient.mrn }}<br>
          <span class="field-label">Patient ID: </span>{{ patient.patientIdFromOrg }}<br>
          <span class="field-label">Phone: </span>{{ patient.phoneNumber }}<br>
          <span class="field-label">E-Mail: </span>{{ patient.email }}<br>
        </div>
        </div>
        <div class="col-2"></div>
        <div class="col-6">
          <div v-if="patient.primaryInsurance"><span class="field-label">Primary: </span><a @click="editInsurance(patient.primaryInsurance)"
                                                       href="#">{{patient.primaryInsurance.insuranceCompany}} <font-awesome-icon
            size="sm" :icon="['far', 'edit']"/>
          </a></div>
          <div v-if="patient.secondaryInsurance"><span class="field-label">Secondary: </span><a @click="editInsurance(patient.secondaryInsurance)"
                                                       href="#">{{patient.secondaryInsurance.insuranceCompany}} <font-awesome-icon
            size="sm" :icon="['far', 'edit']"/>
          </a></div>
          <div v-if="patient.hasEmployerBenefits === true">
            <span class ="episodic-label"><font-awesome-icon class="orange mr-1" size="sm" :icon="['far','chart-network']"/><b>Employer Benefits Available</b></span>
          </div>
          <b-button v-if="!patient.secondaryInsurance || !patient.primaryInsurance" class="mt-3" variant="outline-orange" @click="newInsurance()" :disabled="patientDetailIsLoading === true">
            <font-awesome-icon class="orange mr-1" icon="plus"/>Insurance
            <font-awesome-icon size="lg" class="mr-2" v-show="showingNewInsuranceModal" icon="spinner" pulse/>
          </b-button>
        </div>
      </div>
    </div>
      <div class="row mt-2">
        <div class="col section-header">
          <div class="header-caret" @click.prevent="toggleEstimates"><h5 class="mr-1">ESTIMATES</h5>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingEstimateDetails"/>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingEstimateDetails"/>
          </div>
            <b-button class="ml-4 btn-orange" @click="newEstimate(false)" :disabled="patientDetailIsLoading === true">
              <font-awesome-icon class="white mr-2" icon="plus"/>New Estimate
              <font-awesome-icon size="lg" class="mr-2" v-show="isLoadingNewEstimate" icon="spinner" pulse/>
            </b-button>
        </div>
      </div>
    <hr>
      <transition name="slide">
        <div v-show="showingEstimateDetails" class="col-12">
        <div class="row visits-header">
        <div class="col-2">Last Updated</div>
          <div class="col-2">Type</div>
        <div class="col-2">Provider</div>
        <div class="col-1">Location</div>
        <div class="col-1">Total</div>
        <div class="col-1">Patient Total</div>
        <div class="col-1">Amount Paid</div>
        <div class="col-2"></div>
      </div>
      <div v-for="estimate in patient.estimates" :key="'estimate-' + estimate.organizationPatientEstimateId"
           class="row visit-row" v-if="!estimate.bundle">

        <div class="column col-2">{{ formatDateTime(estimate.updatedAt) }}</div>
        <div class="column col-2">{{displayEstimateType(estimate)}}</div>
        <div class="column col-2">{{ estimate.providerName }}</div>
        <div class="column col-1">{{ estimate.location.name }}</div>
        <div class="column col-1">${{ estimateTotal(estimate) }}</div>
        <div class="column col-1">${{ formatNumber(estimate.patientTotal) }}</div>
        <div class="column col-1">${{ formatNumber(estimate.amountPaid) }}</div>
        <div class="column col-2 text-right">
          <button @click.prevent="editEstimate(estimate)" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>
            Edit
          </button>
          <button v-if="isOrgAdmin" :disabled="estimate.payments.length > 0" title="Delete"
                  @click.prevent="deleteEstimateConfirmation(estimate)" type="button"
                  class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>
            Delete
          </button>
        </div>
      </div>
      <div v-if="patient.estimates && patient.estimates.length === 0" class="row">
        <div class="col">No estimates on file.</div>
      </div>
        </div>
      </transition>
    <div class="row mt-2" v-if="bundlesEnabled">
      <div class="col section-header">
        <div class="header-caret" @click.prevent="toggleEpisodes"><h5 class="mr-1">EPISODES</h5>
          <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingEpisodeDetails"/>
          <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingEpisodeDetails"/>
        </div>
        <b-button class="ml-4 btn-orange" @click="newEstimate(true)" :disabled="patientDetailIsLoading === true">
          <font-awesome-icon class="white mr-2" :icon="['far','chart-network']"/>New Episode
          <font-awesome-icon size="lg" class="mr-2" v-show="isLoadingNewEpisode" icon="spinner" pulse/>
        </b-button>
      </div>
    </div>
    <hr>
    <transition name="slide">
      <div v-show="showingEpisodeDetails" class="col-12">
        <div class="row visits-header">
          <div class="col-2">Last Updated</div>
          <div class="col-2">Type</div>
          <div class="col-2">Provider</div>
          <div class="col-1">Location</div>
          <div class="col-1">Total</div>
          <div class="col-1">Patient Total</div>
          <div class="col-1">Amount Paid</div>
          <div class="col-2"></div>
        </div>
        <div v-for="estimate in patient.estimates" :key="'estimate-' + estimate.organizationPatientEstimateId"
             class="row visit-row" v-if="estimate.bundle">

          <div class="column col-2">{{ formatDateTime(estimate.updatedAt) }}</div>
          <div class="column col-2">{{displayEpisodeType(estimate)}}</div>
          <div class="column col-2">{{ estimate.providerName }}</div>
          <div class="column col-1">{{ estimate.location.name }}</div>
          <div class="column col-1">${{ estimateTotal(estimate) }}</div>
          <div class="column col-1">${{ formatNumber(estimate.patientTotal) }}</div>
          <div class="column col-1">${{ formatNumber(estimate.amountPaid) }}</div>
          <div class="column col-2 text-right">
            <button @click.prevent="editEstimate(estimate)" class="btn btn-outline-orange m-1 wide-button">
              <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>
              Edit
            </button>
            <button v-if="isOrgAdmin" :disabled="estimate.payments.length > 0" title="Delete"
                    @click.prevent="deleteEstimateConfirmation(estimate)" type="button"
                    class="btn btn-outline-orange m-1 wide-button">
              <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>
              Delete
            </button>
          </div>
        </div>
        <div v-if="patient.estimates && patient.estimates.length === 0" class="row">
          <div class="col">No estimates on file.</div>
        </div>
      </div>
    </transition>
      <div class="row mt-2">
        <div class="col section-header">
          <div class="header-caret mr-1" @click.prevent="togglePayments"><h5 class="mr-1">PAYMENTS</h5>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingPaymentDetails"/>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingPaymentDetails"/>
        </div>
        <b-button v-if="isOrgAdmin || isAdmin" class="btn-orange ml-4" @click="savedCards()" :disabled="patientDetailIsLoading === true">
          <font-awesome-icon class="white mr-2" :icon="['far', 'credit-card-front']"/>Saved Cards
        </b-button>
      </div>
      </div>
    <hr>
      <transition name="slide">
        <div v-show="showingPaymentDetails" class="col-12">
      <div class="row visits-header">
        <div class="col-2">Date</div>
        <div class="col-2">Company</div>
        <div class="col-2">Payment Type</div>
        <div class="col-2">Transaction</div>
        <div class="col-1">Amount Paid</div>
        <div class="col-3"></div>
      </div>
      <div class="row visit-row" v-for="(payment, index) in patient.payments"
           :key="'payment-' + index">
        <div class="column col-2">{{ formatDateTime(payment.paymentDate) }}</div>
        <div class="column col-2">{{ payment.organizationName }}</div>
        <div class="column col-2">{{ paymentType(payment) }}</div>
        <div class="column col-2">{{ paymentTypeDisplayName(payment) }}</div>
        <div class="column col-1">$ {{ formatNumber(payment.amount) }}</div>
        <div class="column col-3 text-right">
          <button class="btn btn-outline-orange m-1" @click.stop="showReceipt(payment)">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'file-invoice-dollar']"/>
            Receipt
          </button>
          <button v-if="isOrgAdmin" type="button" :disabled="!isRefundable(payment)"
                  class="mt-2 mb-2 btn btn-outline-orange btn-outline-gray" @click.prevent="refundDialog(payment)">
            Refund
          </button>
        </div>
      </div>
      <div v-if="patient.payments && patient.payments.length === 0" class="row">
        <div class="col">No payments on file.</div>
      </div>
        </div>
      </transition>
      <div class="row mt-2">
        <div class="col section-header">
          <div class="header-caret mr-1" @click.prevent="toggleVisits"><h5 class="mr-1">APPOINTMENTS</h5>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingAppointmentDetails"/>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingAppointmentDetails"/>
          </div>
        </div>
      </div>
    <hr>
      <transition name="slide">
        <div v-show="showingAppointmentDetails" class="col-12">
          <div class="row visits-header">
            <div class="col-2">Date</div>
            <div class="col-1">Type</div>
            <div class="col-1">Flow</div>
            <div class="col-1">Status</div>
            <div class="col-2">Provider</div>
            <div class="col-1">Location</div>
            <div class="col-1">Total</div>
            <div class="col-1">Amount Paid</div>
            <div class="col-2"></div>
          </div>

          <div class="row visit-row" v-for="visit in patient.visits" :key="'visit-' + visit.visitId">
            <div class="column col-2">{{ formatDateTime(visit.appointmentStartDate) }}</div>
            <div class="column col-1">{{ visit.appointmentTypeText }}</div>
            <div class="column col-1">{{ visit.visitTypeName }}</div>
            <div class="column col-1">{{ visit.visitState }}</div>
            <div class="column col-2">{{ visit.provider ? visit.provider.displayName : 'Provider Not Set' }}</div>
            <div class="column col-1">{{ visit.location ? visit.location.name : 'Location Not Set' }}</div>
            <div class="column col-1">$ {{ formatNumber(visit.totalAmount) }}</div>
            <div class="column col-1">$ {{ formatNumber(visit.totalPaid) }}</div>
            <div class="column col-2 text-right">
              <button v-if="visit.totalPaid && visit.totalPaid > 0" class="btn btn-outline-orange m-1" @click.stop="appointmentReceipt(visit)">
                <font-awesome-icon class="orange mr-2" :icon="['far', 'file-invoice-dollar']"/>
                Receipt
              </button>
            </div>
          </div>
        </div>
      </transition>
      <div class="row mt-2">
        <div class="col section-header">
          <div class="header-caret mr-1" @click.prevent="toggleMessages"><h5 class="mr-1">MESSAGES</h5>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingMessageDetails"/>
            <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingMessageDetails"/>
          </div>
          <button :disabled="patientDetailIsLoading === true" v-if="isOrgAdmin" type="button"
                  class="mx-3 ml-4 btn btn-orange btn-outline-gray" @click.prevent="suppressNotifications">
            {{ patient.suppressAllNotifications === true ? 'Enable Visit Notifications' : 'Suppress Visit Notifications'}}
          </button>
          <div v-show="patient.suppressAllNotifications">  <font-awesome-icon class="mr-2 orange" icon="bell-slash"/><b>NOTIFICATIONS SUPPRESSED</b></div>
          </div>
      </div>
    <hr>
      <transition name="slide">
        <div v-show="showingMessageDetails" class="col-12">
      <div class="row visits-header">
        <div class="col-4">Date</div>
        <div class="col-4">Notification Type</div>
        <div class="col-4">Delivered</div>
      </div>
      <div class="row visit-row" v-for="notification in patient.notifications"
           :key="'notification-' + notification.organizationPatientNotificationId">
        <div class="column col-4">{{ formatDateTime(notification.sentAt) }}</div>
        <div class="column col-4">{{ formatNotificationType(notification.notificationType) }}</div>
        <div class="column col-4">{{ notification.phoneNumber ? notification.phoneNumber : notification.email }}</div>
      </div>
        </div>
      </transition>

    <div class="row mt-2">
      <div class="col section-header">
        <div class="header-caret mr-1" @click.prevent="toggleSurveys"><h5 class="mr-1">SURVEYS</h5>
        <font-awesome-icon size="lg" :icon="['fas', 'caret-up']" v-show="!showingSurveyDetails"/>
        <font-awesome-icon size="lg" :icon="['fas', 'caret-down']" v-show="showingSurveyDetails"/>
        </div>
          <b-button v-if="isOrgAdmin || isAdmin" class="btn-orange ml-4" :disabled="patientDetailIsLoading === true" @click.prevent="showSurveySend()">
            <font-awesome-icon class="white mr-2" :icon="['far', 'clipboard-list-check']"/>Send Survey
          </b-button>
    </div>
      </div>
    <hr>
      <transition name="slide">
        <div v-show="showingSurveyDetails" class="col-12">
    <div class="row visits-header">
      <div class="col-3">Date</div>
      <div class="col-3">Name</div>
      <div class="col-3">Score</div>
      <div class="col-3"></div>
    </div>
    <div class="row visit-row" v-for="result in patient.surveyResults"
         :key="'survey-' + result.organizationPatientSurveyResultId">
      <div class="column col-3">{{ formatDateTime(result.createdAt) }}</div>
      <div class="column col-3">{{ result.name }}</div>
      <div v-if="result.scoringType === 'Mapped'" class="column col-3">{{ result.score2 }}</div>
      <div v-else class="column col-3">{{ result.score }}</div>
      <div class="column col-3 text-right"><button type="button" class="mr-2 btn btn-outline-orange float-right" @click.prevent="showSurveyResults(result)">
       Responses
      </button></div>
    </div>
          </div>
      </transition>

  <new-estimate-modal :patient-id="patient.organizationPatientId" :patient-is-self-pay="patient.isSelfPay"
                        :allowable-fee-schedules="newEstimateFeeSchedules"
                        :visible="showingNewEstimateModal" @estimateCreated="estimateCreated" :bundles="bundles"
                        :asc-fee-schedules="newEstimateAscFeeSchedules"
                        :org-patient-insurances="orgPatientInsurances"
                        :employer-benefits="patient.hasEmployerBenefits"
                        @update:visible="visible => showingNewEstimateModal = visible"></new-estimate-modal>
    <new-episode-modal :patient-id="patient.organizationPatientId"
                       :visible="showingNewEpisodeModal"
                       @estimateCreated="estimateCreated"
                       :bundles="bundles"
                       :employerBenefits="employerBenefits"
                       :employers="employers"
                       :patientHasEmployerBundle="patientHasEmployerBundle"
                       @update:visible="visible => showingNewEpisodeModal = visible"></new-episode-modal>
    <refund-modal :payment="activePayment" :visible="showingRefundModal" @refundProcessed="refundProcessed"
                  @update:visible="visible => showingRefundModal = false"></refund-modal>
    <confirm-modal @confirmed="reminderConfirmed" :title="refundReminderTitle"
                   :copy="refundReminderCopy" confirmButton="Ok"
                   :visible="showRefundReminder" :alertOnly="true"
                   @update:visible="visible => showRefundReminder = false"></confirm-modal>
    <pdf-view-modal :title="pdfTitle" :url="pdfUrl" :visible="showingPdfModal"
                    @update:visible="visible => showingPdfModal = visible"></pdf-view-modal>
    <loading-modal :visible="showingLoadingModal"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    <edit-patient-modal :id="editingPatientId" @patientUpdated="patientUpdated" :visible="showingPatientDetails"
                        @update:visible="visible => showingPatientDetails = visible"></edit-patient-modal>
    <card-token-modal :visible="showingTokenModal" :tokens="tokens"
                 @update:visible="visible => showingTokenModal = visible"></card-token-modal>
    <delete-estimate-modal @estimateDeleted="estimateDeleted"
                           :estimate="estimate" :visible="showingDeleteEstimateModal" @update:visible="visible => showingDeleteEstimateModal = visible"></delete-estimate-modal>
    <new-insurance-modal :visible="showingNewInsuranceModal" :id="patient.organizationPatientId" :isPrimaryInsurance="setInsurancePriority()"
                @update:visible="visible => showingNewInsuranceModal = visible" @insuranceUpdated="insuranceUpdated" ></new-insurance-modal>
    <edit-insurance-modal :insurance-details="editingInsurance"
                          @insuranceUpdated="insuranceUpdated" :visible="showingEditInsuranceModal"
                          @update:visible="visible => showingEditInsuranceModal = visible"></edit-insurance-modal>
    <survey-results-modal :visible="showingSurveyResults" @update:visible="visible => showingSurveyResults = visible" :result="visitSurveyResult"></survey-results-modal>
    <patient-survey-modal :visible="showingPatientSurveyModal" :id="patient.organizationPatientId" :patient="patient" @surveySent="surveySent" @update:visible="visible => showingPatientSurveyModal = visible"></patient-survey-modal>

  </div>
</template>

<script>
  import api from '../services/api'
  import moment from 'moment'
  import NewEstimateModal from '../components/NewEstimateModal'
  import RefundModal from '@/components/RefundModal'
  import ConfirmModal from '@/components/ConfirmModal'
  import LoadingModal from '../components/LoadingModal'
  import PdfViewModal from '../components/PdfViewModal'
  import EditPatientModal from '@/components/EditPatientModal'
  import _ from 'lodash'
  import CardTokenModal from '@/components/CardTokenModal'
  import DeleteEstimateModal from '../components/DeleteEstimateModal'
  import NewInsuranceModal from '../components/NewInsuranceModal'
  import EditInsuranceModal from '../components/EditInsuranceModal'
  import SurveyResultsModal from '@/components/SurveyResultsModal'
  import NewEpisodeModal from '@/components/NewEpisodeModal'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import PatientSurveyModal from '@/components/PatientSurveyModal.vue'
  import ErrorsMixin from '../mixins/ErrorsMixin'

  export default {
    name: 'PatientDetail',

    components: { PatientSurveyModal, NewEstimateModal, NewEpisodeModal, RefundModal, ConfirmModal, LoadingModal, PdfViewModal, EditPatientModal, CardTokenModal, DeleteEstimateModal, NewInsuranceModal, EditInsuranceModal, SurveyResultsModal },

    mixins: [AnalyticsMixin, ErrorsMixin],

    props: {
      id: {
        default: 0
      }
    },

    data () {
      return {
        patient: {
          organizationPatientId: 0,
          organizationEmployerId: 0,
          firstName: '',
          lastName: '',
          isSelfPay: false,
          primaryInsurance: '',
          secondaryInsurance: ''
        },
        isLoadingNewEstimate: false,
        isLoadingNewEpisode: false,
        showingNewEstimateModal: false,
        showingNewEpisodeModal: false,
        newEstimateFeeSchedules: [],
        newEstimateAscFeeSchedules: [],
        bundles: [],
        employer: {},
        employerBenefits: [],
        employers: [],
        estimate: {},
        squareImage: true,
        showingRefundModal: false,
        showRefundReminder: false,
        showingPaymentDetails: false,
        showingAppointmentDetails: false,
        showingMessageDetails: false,
        showingSurveyDetails: false,
        showingEstimateDetails: true,
        showingEpisodeDetails: false,
        paymentTypeDisplayNames: {
          PartialRefund: 'Partial Refund',
          Authorize: 'Pending Authorization',
          AuthorizedComplete: 'Completed Authorization'
        },
        activePayment: {},
        showingLoadingModal: false,
        showingSurveyResultsModal: false,
        showingPdfModal: false,
        editingPatientId: 0,
        showingPatientDetails: false,
        showingDeleteEstimateModal: false,
        pdfUrl: '',
        pdfTitle: '',
        patientDetailIsLoading: true,
        showingTokenModal: false,
        tokens: [],
        showingNewInsuranceModal: false,
        showingEditInsuranceModal: false,
        editingInsurance: {},
        orgPatientInsurances: [],
        visitSurveyResult: {},
        showingSurveyResults: false,
        showAlert: false,
        showingPatientSurveyModal: false
      }
    },

    watch: {
      // call again the method if the route changes
      $route: 'loadPatient'
    },

    computed: {
      isOrgAdmin () {
        return this.$store.isOrgAdmin
      },

      isAdmin () {
        return this.$store.isAdmin
      },

      pmType () {
        return this.$store.organization.pmType
      },

      bundlesEnabled () {
        return this.$store.organization.bundlesEnabled
      },

      refundReminderTitle () {
        return 'Update ' + this.pmType
      },

      refundReminderCopy () {
        const paymentdate = moment(this.activePayment.paymentDate).format('MM/DD/YYYY')

        return 'We’ve refunded the payments, but the batch on ' + paymentdate + ' may need to be adjusted in ' + this.pmType + '.'
      },

      patientHasEmployerBundle () {
        return Boolean(this.patient.organizationEmployerId)
      }
    },

    methods: {
      newEstimate (isEpisode) {
        if (isEpisode === true) {
          this.isLoadingNewEpisode = true
          this.loadInsuranceFromIntegration = false
        } else {
          this.isLoadingNewEstimate = true
          this.loadInsuranceFromIntegration = true
          const insurances = []
          if (this.patient.primaryInsurance) {
            insurances.push(this.patient.primaryInsurance)
          }

          if (this.patient.secondaryInsurance) {
            insurances.push(this.patient.secondaryInsurance)
          }
          this.orgPatientInsurances = insurances
        }

        api.get('/Dashboard/Estimate/Patient/' + this.id + '/CreateData', {
          timeout: 180000,
          params: {
            loadInsuranceFromIntegration: this.loadInsuranceFromIntegration
          }
        }).then(response => {
          this.trackEvent(this.$options.name, 'Create', 'ResponseTime', response.config.requestDuration)
          if (isEpisode === true) {
            this.bundles = response.data.bundles
            this.employers = response.data.employers
            this.employer = response.data.employer
            this.employerBenefits = response.data.employerBenefits
            this.isLoadingNewEpisode = false
            this.showingNewEpisodeModal = true
          } else {
            this.newEstimateFeeSchedules = response.data.feeSchedules
            this.newEstimateAscFeeSchedules = response.data.ascFeeSchedules
            this.bundles = response.data.bundles
            this.employer = response.data.employer
            this.employers = response.data.employers
            this.isLoadingNewEstimate = false
            this.showingNewEstimateModal = true
          }
        }).catch(error => {
          this.isLoadingNewEstimate = false
          this.isLoadingNewEpisode = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'CreateError', error)
          }
        })
      },

      editEstimate (estimate) {
        this.$router.push({ name: 'patient-estimate', params: { id: estimate.organizationPatientEstimateId } })
      },

      deleteEstimateConfirmation (estimate) {
        this.showingDeleteEstimateModal = true
        this.estimate = estimate
      },

      estimateDeleted () {
        this.estimate = null
        this.showingDeleteEstimateModal = false
        this.loadPatient()
      },

      togglePayments () {
        this.showingPaymentDetails = !this.showingPaymentDetails
      },

      toggleVisits () {
        this.showingAppointmentDetails = !this.showingAppointmentDetails
      },

      toggleMessages () {
        this.showingMessageDetails = !this.showingMessageDetails
      },

      toggleSurveys () {
        this.showingSurveyDetails = !this.showingSurveyDetails
      },

      toggleEstimates () {
        this.showingEstimateDetails = !this.showingEstimateDetails
      },
      toggleEpisodes () {
        this.showingEpisodeDetails = !this.showingEpisodeDetails
      },
      newInsurance () {
        this.showingNewInsuranceModal = true
      },

      editInsurance (insurance) {
        this.editingInsurance = insurance
        this.showingEditInsuranceModal = true
      },

      insuranceUpdated () {
        this.showingEditInsuranceModal = false
        this.loadPatient()
      },

      setInsurancePriority () {
        if (this.patient.primaryInsurance) {
          return false
        }
        return true
      },

      showSurveyResults (result) {
        this.visitSurveyResult = result
        this.showingSurveyResults = true
      },
      showSurveySend () {
        this.showingPatientSurveyModal = true
      },
      surveySent () {
        this.showingPatientSurveyModal = false
      },
      loadPatient () {
        this.patientDetailIsLoading = true
        api.get('/Dashboard/PatientDetail/' + this.id).then(response => {
          this.trackEvent(this.$options.name, 'Load', 'ResponseTime', response.config.requestDuration)
          this.tokens = response.data.tokens
          this.patient = response.data
          if (!this.patient.imageUrl) {
            this.patient.imageUrl = 'https://s3.amazonaws.com/health-here-assets/Images/PhotoPlaceholder.jpg'
          }
          const tempImg = new Image()
          tempImg.src = this.patient.imageUrl
          tempImg.onload = () => {
            this.squareImage = (tempImg.height - tempImg.width) < 25
          }
          this.patientDetailIsLoading = false
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
          }
          this.patientDetailIsLoading = false
        })
      },

      estimateTotal (estimate) {
        if (!estimate.lines && !estimate.fees) {
          return 0.0
        } else {
          let total = 0.0
          if (estimate.lines) {
            total += estimate.lines.reduce((accumulator, line) => {
              return accumulator + line.price
            }, 0)
          }
          if (estimate.fees) {
            total += estimate.fees.reduce((accumulator, line) => {
              return accumulator + line.amount
            }, 0)
          }
          return this.formatNumber(total)
        }
      },
      showReceipt (payment) {
        this.clearAllErrors()
        if (payment.visitId > 0) {
          this.showVisitReceipt(payment)
        } else if (payment.organizationPatientEstimateId > 0) {
          this.showEstimateReceipt(payment)
        } else if (payment.billId > 0) {
          this.showBillReceipt(payment)
        } else {
          this.showPaymentReceipt(payment)
        }
      },

      getVisitPayment (visit) {
        if (!visit || !Array.isArray(visit.payments) || visit.payments.length === 0) {
          return null
        }

        return visit.payments
          .filter(p => p.creditCardPaymentResult === 'Success')
          .sort((a, b) => b.organizationPatientPaymentId - a.organizationPatientPaymentId)[0]
      },

      showVisitReceipt (payment) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        this.pdfTitle = 'Receipt for ' + this.patient.lastName + ', ' + this.patient.firstName
        api.get('/Dashboard/Download/' + payment.visitId + '/Receipt/', {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Visit', 'Receipt', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'Receipt', 'Show', payment.visitId)

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'Receipt.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'ReceiptError', error.message)
            this.$log.error('Error attempting to load receipt: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      appointmentReceipt (visit) {
        this.clearAllErrors()
        this.showingLoadingModal = true
        this.pdfTitle = 'Receipt for ' + this.patient.lastName + ', ' + this.patient.firstName
        api.get('/Dashboard/Download/' + visit.visitId + '/Receipt/', {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Visit', 'Receipt', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'Receipt', 'Show', visit.visitId)

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'Receipt.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'ReceiptError', error.message)
            this.$log.error('Error attempting to load receipt: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      showPaymentReceipt (payment) {
        this.showingLoadingModal = true
        this.pdfTitle = 'Receipt for ' + this.patient.lastName + ', ' + this.patient.firstName

        api.get('/Dashboard/Download/PaymentReceipt/' + payment.organizationPatientPaymentId, {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Visit', 'Receipt', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'Receipt', 'Show', payment.visitId)

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'Receipt.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'ReceiptError', error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      showBillReceipt (payment) {
        this.showingLoadingModal = true
        this.pdfTitle = 'Receipt for ' + this.patient.lastName + ', ' + this.patient.firstName

        api.get('/Dashboard/Download/' + payment.billId + '/BillReceipt/' + payment.organizationPatientPaymentId, {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('OutstandingPayment', 'Receipt', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('OutstandingPayment', 'Receipt', 'Show', payment.billId)

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'Receipt.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'ReceiptError', error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      showEstimateReceipt (payment) {
        this.showingLoadingModal = true
        this.pdfTitle = 'Receipt for ' + this.patient.lastName + ', ' + this.patient.firstName

        api.get('/Dashboard/Estimate/' + payment.organizationPatientEstimateId + '/Report/' + 'PaymentTransactionReceipt' + '/', {
          responseType: 'blob',
          headers: { 'Content-Type': 'application/pdf' }
        }).then(response => {
          this.trackEvent('Estimate', 'Receipt', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Estimate', 'Receipt', 'Show', payment.estimateId)

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, 'Receipt.pdf')
          } else {
            this.pdfUrl = URL.createObjectURL(response.data)
            this.showingPdfModal = true
          }
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'ReceiptError', error)
          }
        }).then(() => {
          // always executed
          this.showingLoadingModal = false
        })
      },

      formatBirthDate (dob) {
        if (dob) {
          return moment(dob).utc().format('MM/DD/YYYY')
        } else {
          return ''
        }
      },

      formatDate (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY')
        } else {
          return ''
        }
      },

      formatDateTime (date) {
        if (date) {
          return moment(date).format('MM/DD/YYYY hh:mm a')
        } else {
          return ''
        }
      },

      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '0.00'
        }
        if (number) {
          return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }

        return ''
      },

      formatNotificationType (type) {
        return _.startCase(type)
      },

      displayEpisodeType (estimate) {
        if (estimate.bundle) {
          if (estimate.bundle.bundleType === 'SelfPay') {
            return 'Self Pay'
          } else if (estimate.bundle.employer.name) {
            return estimate.bundle.employer.name + ' Episode'
          } else {
            return 'Episodic Payment'
          }
        }
      },

      displayEstimateType (estimate) {
        if (estimate.isSelfPay === true) {
          return 'Self Pay'
        } else {
          return 'Fee for Service'
        }
      },

      estimateCreated (estimate) {
        this.editEstimate(estimate)
      },

      paymentType (payment) {
        if (payment.organizationPatientEstimateId) {
          return 'Estimate'
        } else if (payment.visitId) {
          return 'Visit'
        } else if (payment.billId) {
          return 'Outstanding Balance'
        }

        return 'Unknown'
      },

      isRefundable (payment) {
        if (payment.refundableAmount > 0) {
          return true
        }

        return false
      },

      refundProcessed (response) {
        this.showingRefundModal = false
        this.showRefundReminder = true

        this.loadPatient()
      },

      refundDialog (payment) {
        this.activePayment = payment
        this.showingRefundModal = true
      },

      reminderConfirmed (confirmed) {
        this.showRefundReminder = false
      },

      paymentTypeDisplayName (payment) {
        if (this.paymentTypeDisplayNames[payment.creditCardPaymentType]) {
          return this.paymentTypeDisplayNames[payment.creditCardPaymentType]
        }

        return payment.creditCardPaymentType
      },

      editPatient (patientId) {
        this.editingPatientId = patientId
        this.showingPatientDetails = true
      },

      patientUpdated (updatedPatient) {
        this.showingPatientDetails = false
        this.loadPatient()
      },

      suppressNotifications () {
        this.patient.suppressAllNotifications = !this.patient.suppressAllNotifications

        api.post('Dashboard/PatientDetail/' + this.patient.organizationPatientId, this.patient).then(() => {
          this.loadPatient()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to suppress patient notifications: ' + error.message, error)
          }
        })
      },

      savedCards () {
        this.showingTokenModal = true
      }
    },

    created () {
      this.loadPatient()
    }
  }
</script>

<style scoped>
.patient-summary-header {
  border-top: 1px solid #FFA800;
  background-color: #f9f9f9;
}

.patient-summary-header h5 {
  color: #001859;
}

.patient-summary .column {
  padding: 0.75rem;
  vertical-align: bottom;
  border-collapse: collapse;
}

.patient-summary {
  border-bottom: 1px solid #dee2e6;
  background-color: #f9f9f9;
  /*cursor: pointer;*/
}

.header-row div {
  padding: 0.75rem;
  vertical-align: bottom;
  border-top: 1px solid #dee2e6;
  border-bottom: 2px solid #dee2e6;
  font-weight: bold;
  border-collapse: collapse;
}

.rectangle-headshot-container {
  height: 125px;
  width: 125px;
  border-radius: 50%;
  border: #FFA800 1px solid;
  overflow: hidden;
}

.rectangle-headshot {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  vertical-align: top;
  margin: -10px 0 0 0;
  padding: 0;
  top: 0;
  right: 0;
  image-orientation: none;
}

.section-header {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-left: 5px;
}

.visits-header div {
  padding: 0.75rem;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  font-weight: bold;
  border-collapse: collapse;
}

.visit-row .column {
  padding: 0.75rem;
  vertical-align: bottom;
  border-collapse: collapse;
}

.visit-row {
  border-bottom: 1px solid #dee2e6;
  background-color: #f9f9f9;
}

.header-caret {
  cursor: pointer;
  display: flex;
}

.header-caret:hover {
text-decoration: underline;
}

hr {
  margin-bottom: 0px;
}

.survey-container {
  margin-bottom: 100px;
}

.patient-info {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
